import { IStyle } from "@fluentui/react";

// Consolidate table styles for easier maintenance
const borderStyle = "1px solid #ddd";
const baseCellPadding = "6px";
const headerCellPadding = "8px";

export const tableContainerStyle = {
  marginTop: 20,
  maxHeight: 300,
  overflow: "auto"
};

export const tableStyle = {
  width: "100%",
  borderCollapse: "collapse" as const,
  fontSize: "12px"
};

export const tableHeaderRowStyle = {
  backgroundColor: "#f3f2f1"
};

export const tableHeaderCellStyle = {
  padding: headerCellPadding,
  border: borderStyle
};

export const tableCellStyle = {
  padding: baseCellPadding,
  border: borderStyle
};

export const tableTitleStyle = {
  fontWeight: 600,
  marginBottom: 10
};

// Consolidate dropdown and stack styles for consistency and easier updates
const minWidth = (width: number) => ({ minWidth: width });
const maxWidth = (width: number) => ({ maxWidth: width });

export const dropdownStyle = { dropdown: minWidth(200) };
export const chartHeightDropdownStyle = { dropdown: minWidth(150) };
export const featureStackStyle = { ...minWidth(200), ...maxWidth(300), flex: 1 };
export const chartHeightStackStyle = minWidth(150);
export const toggleStackStyle = minWidth(120);
export const disabledToggleStyle = { root: { cursor: "not-allowed", opacity: 0.6 } };
export const loadingStateStackStyle = {
  root: { alignItems: "center", justifyContent: "center", height: "100%" }
};

export const featureChartStackStyle = {
  border: borderStyle,
  borderRadius: 4,
  padding: 10,
  marginTop: 15
};

export const featureChartTitleStyle = {
  root: { fontWeight: 700 } as IStyle
};
